export enum RolEnum {
  'ADMIN' = 'ADMIN',
  'JEFE_OBRA' = 'JEFE_OBRA',
  'RESP_PLANT' = 'RESP_PLANT',
  'ENCARGADO' = 'ENCARGADO',
  'MAQUINISTA' = 'MAQUINISTA'
}
